export function AnimatedAccordionIcon() {
  return (
    <div className="relative flex h-2.5 w-2.5 items-center justify-center">
      <div className="absolute h-0.5 w-2.5 rounded-full bg-current transition-all duration-200" />
      <div className="-rotate-90 absolute h-0.5 w-2.5 origin-center rounded-full bg-current transition-all group-data-[panel-open]:rotate-0" />
    </div>
  );
}
